function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay.js');
var CallScheduleJoinTemplate = require('./call-schedule-join.template.js');
var CallScheduleJoin = /*#__PURE__*/function () {
  function CallScheduleJoin(app, mod, keys) {
    var _this = this;
    _classCallCheck(this, CallScheduleJoin);
    this.app = app;
    this.mod = mod;
    this.keys = keys;
    this.overlay = new SaitoOverlay(app, mod);
    app.connection.on('remove-call-schedule-join', function () {
      _this.remove();
    });
  }
  return _createClass(CallScheduleJoin, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var auto_join = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.keys.length == 0) {
        this.remove(false);
        return;
      }
      if (!document.querySelector('.call-schedule-join-container')) {
        this.overlay.show(CallScheduleJoinTemplate(this, auto_join), function () {
          _this2.remove(false);
        });
        this.attachEvents(auto_join);
      }
      return true;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(auto_join) {
      var _this3 = this;
      var now = new Date().getTime();
      var _iterator = _createForOfIteratorHelper(this.keys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var event = _step.value;
          this.updateButtonState(event, now);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      document.querySelectorAll('.enter-call-button').forEach(function (c) {
        c.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var id, _iterator2, _step2, k, parsedLink, rCode, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  id = e.currentTarget.dataset.id;
                  _iterator2 = _createForOfIteratorHelper(_this3.keys);
                  _context.p = 1;
                  _iterator2.s();
                case 2:
                  if ((_step2 = _iterator2.n()).done) {
                    _context.n = 5;
                    break;
                  }
                  k = _step2.value;
                  if (!(k.publicKey == id)) {
                    _context.n = 4;
                    break;
                  }
                  _this3.link = k.link;
                  parsedLink = _this3.link.split('stun_video_chat=');
                  rCode = parsedLink.pop();
                  _this3.mod.room_obj = JSON.parse(_this3.app.crypto.base64ToString(rCode));
                  _this3.remove(auto_join);
                  if (!auto_join) {
                    _context.n = 3;
                    break;
                  }
                  _this3.app.connection.emit('call-launch-enter-call');
                  _context.n = 4;
                  break;
                case 3:
                  _context.n = 4;
                  return _this3.mod.copyInviteLink();
                case 4:
                  _context.n = 2;
                  break;
                case 5:
                  _context.n = 7;
                  break;
                case 6:
                  _context.p = 6;
                  _t = _context.v;
                  _iterator2.e(_t);
                case 7:
                  _context.p = 7;
                  _iterator2.f();
                  return _context.f(7);
                case 8:
                  return _context.a(2);
              }
            }, _callee, null, [[1, 6, 7, 8]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      });
      document.querySelectorAll('.delete-call-button').forEach(function (c) {
        c.onclick = function (e) {
          var id = e.currentTarget.dataset.id;
          for (var i = _this3.keys.length - 1; i >= 0; i--) {
            if (_this3.keys[i].publicKey == id) {
              _this3.keys.splice(i, 1);
            }
          }
          _this3.app.keychain.removeKey(id);
          // maybe send a cancel transaction?
          _this3.overlay.remove();
          _this3.render();
        };
      });
      if (document.getElementById('create-new-room')) {
        document.getElementById('create-new-room').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this3.remove(auto_join);
                  _context2.n = 1;
                  return _this3.mod.createRoom();
                case 1:
                  _this3.link = _context2.v;
                  if (!auto_join) {
                    _context2.n = 2;
                    break;
                  }
                  _this3.app.connection.emit('call-launch-enter-call');
                  _context2.n = 3;
                  break;
                case 2:
                  _context2.n = 3;
                  return _this3.mod.copyInviteLink();
                case 3:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState(event) {
      var _this4 = this;
      var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      var card = document.querySelector(".call-schedule-card-container[data-id=\"".concat(event.publicKey, "\"]"));
      if (!card) return;
      if (now - event.startTime > -5 * 60 * 1000) {
        card.querySelector('.enter-call-button').classList.remove('hidden');
      }
      if (now - event.startTime < 0) {
        // joinButton.classList.add('disabled');
        var timeLeft = this.getTimeLeft(now, event.startTime);
        card.querySelector('.call-countdown').textContent = "Call starts in ".concat(timeLeft);
        setTimeout(function () {
          _this4.updateButtonState(event);
        }, 1000);
      } else {
        card.querySelector('.call-countdown').textContent = "Call has begun!";
      }
    }
  }, {
    key: "getTimeLeft",
    value: function getTimeLeft(now, startTime) {
      var diff = startTime - now;
      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(diff % (1000 * 60) / 1000);
      return "".concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0'));
    }
  }, {
    key: "remove",
    value: function remove() {
      var auto_join = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.overlay.remove();
      this.app.connection.emit('close-preview-window', !auto_join);
    }
  }]);
}();
module.exports = CallScheduleJoin;